import { render, staticRenderFns } from "./SimpleChatGreenIcon.vue?vue&type=template&id=05f098c0&"
import script from "./SimpleChatGreenIcon.vue?vue&type=script&lang=ts&"
export * from "./SimpleChatGreenIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports